import { axiosObject } from "../config";

export default function getAllPYPByUser(id: any, page: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/posted_properties/_read";
    let payload = {
      limitBy: {
        per_page: 5,
        page: page,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "user_uuid",
          op: "eq",
          value: id,
        },
        {
          attribute: "deleted_at",
          op: "is",
          value: null,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
